import { render, staticRenderFns } from "./DialogSelectStandardText.vue?vue&type=template&id=8fa4f048"
import script from "./DialogSelectStandardText.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSelectStandardText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports